import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from 'app/services/models/company.service';
import { PdfService } from 'app/services/models/pdf.service';
import { TransactionDescriptionService } from 'app/services/models/transaction-description.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { ToastrService } from 'ngx-toastr';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
import htmlToPdfmake from 'html-to-pdfmake';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-sendpdf-dialog',
  templateUrl: './sendpdf-dialog.component.html',
  styleUrls: ['./sendpdf-dialog.component.scss']
})
export class SendpdfDialogComponent implements OnInit {
  @Input() data: { title: string, description: string, transactionId: number };
  form: FormGroup;
  pdfs: any[] = []

  descriptions: any[] = [];

  pdf: any = {};
  transaction: any = {};
  company: any = {};

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private pdfService: PdfService,
    private transactionService: TransactionService,
    private companyService: CompanyService,
    private toastService: ToastrService,
    private transactionManagementDescription: TransactionDescriptionService
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      mail: ['', [Validators.required, Validators.email]],
      pdfId: [null, Validators.required],
      title: [this.data.title, Validators.required],
      description: [this.data.description, Validators.required],
      descriptionId: [null]
    });
    await this.getAllPdf();
    await this.getAllDescription();
    await this.getByIdTransaction(this.data.transactionId);
  }

  async getAllDescription() {
    const data = await this.transactionManagementDescription.getAllTransactionDescriptions();
    this.descriptions = data;
    console.log(this.descriptions)
  }

  async getByIdTransaction(transactionId) {
    const data = await this.transactionService.getByIdTransaction(transactionId);
    console.log(data);
    this.transaction = data;
    await this.companyById(1)
  }

  async getAllPdf() {
    const data = await this.pdfService.getAllPdfsList(0, 100);
    this.pdfs = data.pdfs;
    console.log(this.pdfs);
    if (this.pdfs) {
      this.form.patchValue({
        pdfId: this.pdfs[0].id
      });
      console.log(this.form.value.pdfId)
      await this.getByIdPdf(this.form.value.pdfId);
    }
  }

  async getByIdPdf(id) {
    const data = await this.pdfService.getByIdPdf(id);
    console.log(data);
    this.pdf = data;
  }
  closeModal() {
    this.activeModal.close(false);
  }

  submitForm() {
    if (this.form.valid) {
      console.log(this.form.value);
      this.generatePDF();
    }
  }

  pdfBaslik = [
    { name: "Ürün adı", width: 200, isEye: true },
    { name: "Adet", width: 0, isEye: true },
    { name: "Fiyat", width: 0, isEye: true },
    { name: "Para Birimi", width: 0, isEye: true },
    { name: "Birim", width: 0, isEye: true },
  ];

  getFileTypeFromUrl(url: string): string | null {
    const fileExtensionPattern = /\.(png|jpg|jpeg)$/i; // Geçerli dosya uzantıları
    const match = url.match(fileExtensionPattern);
    return match ? match[0].substring(1) : null; // Uzantıyı döndür (örneğin, "png", "jpg")
  }

  public getBase64ImageUrl(base64: string, fileUrl?: string): string {
    const type = this.getFileTypeFromUrl(fileUrl) ?? 'jpeg';
    console.log(type);
    return `data:image/${type};base64,${base64}`;
  }

  async companyById(id) {
    const data = await this.companyService.getByIdCompany(id);
    this.company = data;
    console.log(this.company);
  }

  generatePDF(): void {
    const products = this.transaction?.transactionManagementProducts;
    const transactionDescription = this.transaction?.transactionManagementDescriptionConnects[0]?.description;
    let descriptionTransaction: any[] = [];

    if (transactionDescription) {
      descriptionTransaction = htmlToPdfmake(transactionDescription);
      console.log(descriptionTransaction);
    }

    // Toplamlar hesaplanıyor
    const totalCount = this.sumCount();
    const totalGross = this.sumGross();
    const totalDiscount = this.sumDiscount();
    const netTotal = this.sumNetTotal();
    const taxTotals = this.calculateTaxTotal();
    const currencyTotals = this.calculateCurrencyTotal();

    const documentDefinition: TDocumentDefinitions = {
      content: [
        {
          columns: [
            {
              // First column: Company logo and title
              columns: [
                this.company.companyFile64 ? {
                  image: this.getBase64ImageUrl(this.company?.companyFile64, this.company?.companyFile),
                  width: 100,
                  height: 100,
                  margin: [0, 0, 0, 0] // Margin: [left, top, right, bottom]
                } : {
                  text: this.pdf.title,
                  style: 'header',
                  margin: [0, 25, 0, 0], // Adjust the top margin to align with the logo
                  alignment: 'left' // Ensure title is left aligned
                },
                this.company.companyFile64 ? {
                  text: this.pdf.title,
                  style: 'header',
                  margin: [0, 25, 0, 0], // Adjust the top margin to align with the logo
                  alignment: 'left' // Ensure title is left aligned
                }:""
              ],
              width: '*', // Allow it to take available space
            },
            // Second column: PDF logo
            this.pdf.files?.length > 0 ? {
              image: this.getBase64ImageUrl(this.pdf.files[0].base64Image),
              width: 100,
              height: 100,
              alignment: 'right'
            } : { text: '' }
          ],
          columnGap: 10 // Gap between the first and second column
        },
        {
          columns: [
            {
              width: 250,
              stack: [
                { text: this.pdf.titleDescription, fontSize: 10 }
              ]
            },

          ],
          marginBottom: 30
        },
        {
          columns: [
            {
              stack: [
                { text: `Teklif Verilen Şirket: ${this.transaction.companyName}`, style: 'companyInfo' },
                this.transaction.personName ? { text: `Sorumlu Kişi: ${this.transaction.personName} ${this.transaction.personLastName}`, style: 'companyInfo' } : { text: '' },
                this.transaction.personPhoneNumber ? { text: `Telefon No: ${this.transaction.personPhoneNumber}`, style: 'companyInfo' } : { text: '' },
                this.transaction.companyAddress ? { text: `Adres: ${this.transaction.companyAddress}`, style: 'companyInfo' } : { text: '' }
              ],
              width: '50%'
            },
            {
              width: '50%',
              stack: [
                { text: `Tarih: ${new Date(this.transaction.transactionCraetedAt).toLocaleDateString()}`, style: 'companyInfo', alignment: 'right' },
                { text: `Teklif No: ${this.transaction.no}`, style: 'companyInfo', alignment: 'right' },
                { text: "Ödeme: 30 Gün", style: 'companyInfo', alignment: 'right' }
              ]
            }
          ]
        },
        { text: this.pdf.description, margin: [0, 0, 0, 15] },
        {
          table: {
            widths: this.pdfBaslik.map(p => p.width || '*'),
            body: [
              this.pdfBaslik.map(title => ({ text: title.name, bold: true, fillColor: "#2980ba", color: "#ffffff" })),
              ...products.map(urun => [
                urun.productName,
                urun.productCount,
                urun.productPrice,
                urun.currency,
                urun.unitTypeName,
              ]),
            ],
          },
          layout: {
            fillColor: function (rowIndex: number) {
              return (rowIndex % 2 === 0) ? '#EAEAEA' : null;
            },
            hLineWidth: function () { return 0.5; },
            vLineWidth: function () { return 0.5; },
            hLineColor: function () { return 'black'; },
            vLineColor: function () { return 'black'; },
          }
        },
        // Toplam bilgilerini içeren bir sütun
        {
          columns: [
            { text: '', width: '50%' }, // Boş bir hücre ekleyin
            {
              width: '50%',
              stack: [
                { text: `Toplam Miktar: ${totalCount}`, fontSize: 10, margin: [0, 5], alignment: 'right' },
                { text: `Brüt Toplam: ${totalGross}`, fontSize: 10, margin: [0, 5], alignment: 'right' },
                { text: `Toplam İndirim: ${totalDiscount}`, fontSize: 10, margin: [0, 5], alignment: 'right' },
                { text: `Net Toplam: ${netTotal}`, fontSize: 10, margin: [0, 5], alignment: 'right' },
                ...taxTotals.map(item => ({
                  text: `KDV %${item.taxRate}: ${item.totalTax}`,
                  fontSize: 10,
                  margin: [0, 5],
                  alignment: 'right' as const // `alignment` property's type should be one of the predefined values
                })),
                ...currencyTotals.map(item => ({
                  text: `Toplam Tutar (${item.currency}): ${item.totalAmount}`,
                  fontSize: 10,
                  margin: [0, 5],
                  alignment: 'right' as const
                })),
                { text: `Genel Toplam: ${this.calculateGeneralTotal()}`, fontSize: 10, margin: [0, 5], alignment: 'right' }
              ] as Content[] // Specify the correct type for the stack
            }
          ],
          margin: [0, 20, 0, 0] as [number, number, number, number] // Ensure the margin is correctly typed
        },
        transactionDescription ? { stack: descriptionTransaction, pageBreak: 'before' } : { text: '' },
      ],
      footer: (currentPage, pageCount) => {
        return {
          stack: [
            { text: `Sayfa ${currentPage} / ${pageCount}`, alignment: 'center', margin: [0, 0, 0, 5] },
            { text: this.pdf.footer, alignment: 'center', margin: [0, 0, 0, 10] }
          ],
          style: 'footer',
          alignment: 'center'
        };
      },

      styles: {
        header: { fontSize: 16, bold: true },
        date: { alignment: 'right' },
        subheader: { fontSize: 14, bold: true, margin: [0, 20, 0, 10] },
        footer: { fontSize: 10, margin: [0, 0, 0, 0] },
        listStyle: {
          margin: [0, 0, 0, 20],
          alignment: 'left'
        }
      },
      pageMargins: [40, 60, 40, 60]
    };
    /*
    pdfMake.createPdf(documentDefinition).getBlob(async (blob) => {
      const response = await this.pdfService.sendPdf(this.form.value.title, this.form.value.description, this.form.value.mail, [blob]);
      console.log(response);
      if (response.status) {
        this.toastService.success(response.message);
      } else {
        this.toastService.error(response.message);
      }
    });
    */
    pdfMake.createPdf(documentDefinition).open()
    this.closeModal();
  }

  sumCount(): number {
    return this.transaction.transactionManagementProducts?.reduce((sum, product) => sum + product.productCount, 0) || 0;
  }

  sumGross(): number {
    return this.transaction.transactionManagementProducts?.reduce((sum, product) => {
      const total = product.productPrice * product.productCount;
      return sum + total;
    }, 0) || 0;
  }

  sumDiscount(): number {
    return this.transaction.transactionManagementProducts?.reduce((sum, product) => {
      const discount = (product.productPrice * product.discountRate / 100) * product.productCount;
      return sum + discount;
    }, 0) || 0;
  }

  sumNetTotal(): number {
    const grossTotal = this.sumGross();
    const totalDiscount = this.sumDiscount();
    return grossTotal - totalDiscount;
  }

  calculateTaxTotal(): any[] {
    const taxTotals = [];
    this.transaction.transactionManagementProducts?.forEach(product => {
      const taxAmount = (product.productPrice * product.taxRate / 100) * product.productCount;
      const existingTax = taxTotals.find(t => t.taxRate === product.taxRate);
      if (existingTax) {
        existingTax.totalTax += taxAmount;
      } else {
        taxTotals.push({ taxRate: product.taxRate, totalTax: taxAmount });
      }
    });
    return taxTotals;
  }

  calculateCurrencyTotal(): any[] {
    const currencyTotals = [];
    this.transaction.transactionManagementProducts?.forEach(product => {
      const totalAmount = product.productPrice * product.productCount;
      const existingCurrency = currencyTotals.find(c => c.currency === product.currency);
      if (existingCurrency) {
        existingCurrency.totalAmount += totalAmount;
      } else {
        currencyTotals.push({ currency: product.currency, totalAmount: totalAmount });
      }
    });
    return currencyTotals;
  }

  calculateGeneralTotal(): number {
    return this.sumNetTotal() + this.calculateTaxTotal().reduce((sum, item) => sum + item.totalTax, 0);
  }
}
